exportedVariables